import React, { useEffect, useRef, useState } from "react";
import engine from "../../../../../assets/image/category/engine.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import sensor1 from "../../../../../assets/image/services/sensor1.webp";
import sensor2 from "../../../../../assets/image/services/sensor2.webp";
import sensor3 from "../../../../../assets/image/services/sensor3.webp";
import engine4 from "../../../../../assets/image/services/engine4.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";

export default function EngineDiagnostics() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <>
      <div className="text-black max-w-full  md:w-full overflow-x-hidden">
        {/* Diagnostics Services*/}

        <div className="text-black  md:w-full  ">
          {/* Image Column (5/12 on large) */}
          <div className="lg:col-span-5 md:col-span-1 relative max-w-full   ">
            <img
              className=" lg:h-[30rem] md:w-full md:h-[25rem] h-[22rem] w-full object-cover "
              src={engine}
              alt="engine"
            />
            <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/65 to-transparent"></div>
            <div className="absolute inset-0 lg:mb-20 mb-14 flex items-center justify-center text-white text-center ">
              <h3
                className={`text-white font-bold absolute text-center lg:text-[3.75rem] md:text-5xl  text-2xl
            
             transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
              >
                VAP Engine Diagnostics Services
              </h3>
            </div>
            <div
              className={`w-full flex items-center absolute inset-0 justify-center lg:pt-[35px] md:pt-10 mt-4 text-white text-center
              transition-all duration-[900ms]  delay-1000 ease-out transform 
                ${isVisible
                  ? "-translate-y-0 opacity-100"
                  : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
                <MyButton
                  text=" Diagnostics Services"
                  className="bg-orange-500 text-white py-[13px]   rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
                />
              </Link>
            </div>
          </div>

          {/* Content Column (7/12 on large) */}
          <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-[30px] lg:px-[12%] ">
            <div className="container mx-auto px-6 max-w-4xl  text-center ">
              <p className="text-xl lg:block md:block hidden text-gray-700 mb-3 leading-relaxed">
                Is your check engine light on, or have you noticed reduced fuel
                efficiency, rough idling, or sluggish performance? These
                symptoms can signal underlying engine issues that, if left
                unchecked, may lead to more serious and expensive problems down
                the road.
              </p>

              <p className="text-xl text-gray-700 mb-6   leading-relaxed">
                At Vancouver Auto Parts, our experienced technicians use
                advanced diagnostic tools to quickly identify the root cause of
                any engine warning. Whether your vehicle uses OEM parts or
                aftermarket upgrades, we’ll ensure it’s running at peak
                performance and help you avoid costly repairs.
              </p>

              {/* <ul className=" ps-1">
                <li className="hover:text-blue-900 flex item-center text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className=" text-white p-0.5" />
                  </span>
                  Check Engine Light is on or flashing
                </li>
                <li className="hover:text-blue-900 flex item-center text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className=" text-white p-0.5" />
                  </span>
                  Rough idling, misfires, or stalling
                </li>
                <li className="hover:text-blue-900 flex item-center text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className=" text-white p-0.5" />
                  </span>
                  Poor acceleration or reduced fuel efficiency
                </li>
                <li className="hover:text-blue-900 flex item-center text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className=" text-white p-0.5" />
                  </span>{" "}
                  Unusual engine noises or vibrations
                </li>
                <li className="hover:text-blue-900 flex item-center text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className=" text-white p-0.5" />
                  </span>
                  Excessive exhaust smoke or burning smells
                </li>
              </ul> */}
            </div>
            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out
                ${isVisible
                  ? "-translate-y-0 opacity-100"
                  : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
                <MyButton
                  text="Book same-day diagnostic test "
                  className="mx-auto py-[12px] transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#EFF6FF]">
        <div className="lg:py-[20px] md:py-[20px] py-[15px] container">
          <h1 className="text-blue-900 font-bold text-[2.23rem] md:text-[2.6rem] lg:text-[3rem]   text-center mb-3">
            Engine Diagnostics Services
          </h1>
          <p className=" lg:font-normal text-center lg:mb-10  text-[1.35rem] lg:px-[9%]">
            Your car engine relies on an intricate system of sensors, fuel
            injectors, and electronic controls. When something isn't right, your
            check engine light is the first warning, indicating a potential
            problem. At Vancouver Auto Parts, we use{" "}
            <b>advanced diagnostic tools</b> to identify faults in your engine,
            transmission, fuel system.
          </p>

          <div className="flex justtify-center items-center lg:px-[5%] py-3  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={sensor1}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Engine Sensors{" "}
                      <span className="text-[#2772AD]">Matter </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    A faulty sensor may seem minor, but it can throw off your
                    engine timing, fuel efficiency, and emissions. Left
                    unchecked, this can lead to sudden power loss, poor
                    acceleration, or engine stalling. Timely diagnostic checks
                    prevent cascading issues, avoiding unexpected breakdowns and
                    expensive repairs down the road.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[5%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Don’t Ignore the{" "}
                      <span className="text-[#2772AD]">Light</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    A glowing check engine light is more than just a
                    warning—it's your vehicle asking for attention. Ignoring it
                    can turn simple fixes into major repairs. From engine
                    misfires to failing sensors and can early detection helps
                    avoid expensive damage. Stay ahead of trouble and keep your
                    car running smoothly with timely diagnostics.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={sensor3}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={engine4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Data Drives{" "}
                      <span className="text-[#2772AD]">Performance</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    Today’s engines rely on precise sensor data to adjust fuel,
                    ignition, and emissions in real time. When even one sensor
                    gives faulty readings, it can affect power, fuel economy,
                    and overall driveability. Small errors in one area often
                    ripple across systems, creating bigger issues that reduce
                    performance and increase repair costs.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="lg:w-[53vw] mx-auto flex flex-col justify-between bg-white lg:px-4  p-3  mb-3 text-center rounded-2xl shadow ">
            <div>
              <p className="text-blue-900 font-bold text-2xl md:text-3xl mb-2">
                Comprehensive Engine Diagnostics
              </p>
              <p className="text-lg md:text-xl mb-3">
                Our expert diagnostics cover every major engine component to
                identify issues early and keep your vehicle running smoothly.
                Whether it's a sensor fault or a fuel system issue, we’ll find
                the problem before it becomes a costly repair.
              </p>
            </div>
            {/* <div className="container py-[30px] ">
              <h1
                className="text-blue-900 font-bold lg:text-5xl md:text-4xl mb-3 lg:px-20 "
                style={{ textAlign: "left" }}
              >
                More Services
              </h1>
              <ul className="text-white-900 text-lg space-y-4 lg:px-20">
                <li className="flex flex-col md:flex-row md:items-center md:space-x-2">
                  <div className="flex items-center space-x-2">
                    <img src={check} className="h-6 w-6" />
                    <b>Check Engine Light Analysis</b>
                  </div>
                  <span className="md:inline md:ml-2">
                    – Determines the cause of the warning light.
                  </span>
                </li>
                <li className="flex flex-col md:flex-row md:items-center md:space-x-2">
                  <div className="flex items-center space-x-2">
                    <img src={check} className="h-6 w-6" />
                    <b>Sensor & Code Readings</b>
                  </div>
                  <span className="md:inline md:ml-2">
                    – Detects faulty sensors and system errors.
                  </span>
                </li>
                <li className="flex flex-col md:flex-row md:items-center md:space-x-2">
                  <div className="flex items-center space-x-2">
                    <img src={check} className="h-6 w-6" />
                    <b>Fuel System Inspection</b>
                  </div>
                  <span className="md:inline md:ml-2">
                    – Assesses fuel injectors, pumps, and pressure regulators.
                  </span>
                </li>
                <li className="flex flex-col md:flex-row md:items-center md:space-x-2">
                  <div className="flex items-center space-x-2">
                    <img src={check} className="h-6 w-6" />
                    <b>Ignition System Testing</b>
                  </div>
                  <span className="md:inline md:ml-2">
                    – Detects misfires, coil failures, and spark plug issues.
                  </span>
                </li>
              </ul>
            </div> */}

          {/* <div className="space-y-2">
              {[
                "Check Engine Light Analysis",
                "Sensor & Code Readings",
                "Fuel System Inspection",
                "Ignition System Testing",
                "Cooling System Assessment",
                "Air Intake & Emissions Check",
              ].map((category, idx) => (
                <span
                  key={idx}
                  className="p-2   text-blue-900 font-semibold text-xl rounded-xl cursor-pointer hover:bg-blue-200 transition flex gap-2 items-center"
                >
                  <img src={check} className="h-6 w-6" />
                  {category}
                </span>
              ))}
            </div>

            <div className="lg:pt-2">
              <Link to="/contact-us">
                {/* <button className="w-full flex justify-center items-center px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white text-lg font-semibold rounded-full transition">
                    Get a FREE Estimate today <FaArrowRight className="ml-3" />
                  </button> */}
          {/* <MyButton
                  text="Get a FREE Estimate today"
                  className="w-full flex justify-center items-center px-3 py-3 bg-blue-600  text-white text-lg font-semibold rounded-full transition"
                />
              </Link>
            </div>
          </div> */}

          <div className="lg:px-28 text-center ">
            <h1
              className="text-blue-900 font-bold lg:text-5xl md:text-4xl   mb-3 px-1"
              style={{ textAlign: "center" }}
            >
              Beyond the Warning Light{" "}
            </h1>
            <p className="mb-4 lg:font-normal  text-[1.35rem]  ">
              Engine issues don’t always show immediate symptoms. A
              malfunctioning sensor or clogged fuel injector can significantly
              increase fuel consumption, reduce overall engine lifespan, and
              impact emissions compliance. Routine diagnostics help to keep your
              engine running smoothly while preventing expensive repairs.
            </p>

            <p className="mb-4 lg:font-normal  text-[1.35rem] lg:block md:block hidden  px-1">
              At Vancouver Auto Parts, we offer a comprehensive selection of high-quality aftermarket and OEM auto parts across Canada, ensuring reliable performance and durability for your vehicle.
            </p>
            <div className="w-full flex justify-center lg:mt-5 mb-3 transform transition-transform duration-500 hover:scale-105">
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer flex items-center">
                  Same-day FREE inspection—Drive in today! <FaArrowRight className="ml-2" />
                </button> */}

                <MyButton text="Same-day FREE inspection  " />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style>{`
.tick-list {
  list-style: none;
  padding: 0;
}

.tick-list li {
  position: relative;
  padding-left: 24px;
}

.tick-list li::before {
  content: "✔"; 
  color: green;
  font-weight: bold;
  position: absolute;
  left: 0;
}
`}</style>
    </>
  );
}
